import React from "react";
import styles from "./KropkiLadowania.module.css";

/**
 * [S19 2026-09-14] TRZY SKACZĄCE KROPKI — jedyny wskaźnik „coś się dzieje” w aplikacji.
 *
 * Wygląd wg przykładu wskazanego przez właściciela (codepen nikhil8krishnan/pen/rVoXJa, „skaczące kropki”),
 * odtworzony własnym CSS na tokenach akcentu — bez kopiowania cudzego kodu.
 * Zastępuje wzorzec `.loadingSpinner` (kółko) z DESIGN-SYSTEM-PODSTRON §8, który kazał każdej podstronie
 * budować własną kopię — stąd kilkadziesiąt lokalnych `@keyframes spin*`.
 *
 * DOSTĘPNOŚĆ: domyślnie `role="status"` z niewidocznym tekstem „Ładowanie…” (czytnik ekranu dostaje słowo,
 * a nie trzy puste elementy). `ozdobne` = kropki wewnątrz kontenera, który SAM ogłasza stan (np. LadowanieStrony,
 * przycisk z `aria-busy`) — wtedy są ukryte przed czytnikiem, żeby stan nie był ogłaszany dwa razy.
 * Ruch: przy `prefers-reduced-motion: reduce` kropki nie skaczą, tylko łagodnie pulsują jasnością.
 *
 * @param {object} props
 * @param {"sm"|"md"|"lg"} [props.rozmiar="md"] sm — w przycisku / w linii tekstu; md — sekcja; lg — cała strona
 * @param {string} [props.etykieta="Ładowanie…"] tekst dla czytnika ekranu
 * @param {boolean} [props.ozdobne=false] bez roli i bez tekstu (stan ogłasza rodzic)
 * @param {"akcent"|"tekst"} [props.kolor="akcent"] „tekst” = kolor bieżącego tekstu (np. na przycisku z akcentem)
 * @param {string} [props.className]
 */
const KropkiLadowania = ({ rozmiar = "md", etykieta = "Ładowanie…", ozdobne = false, kolor = "akcent", className = "" }) => {
    const klasy = [
        styles.kropki,
        styles[rozmiar] || styles.md,
        kolor === "tekst" ? styles.kolorTekstu : "",
        className,
    ].filter(Boolean).join(" ");

    const kropki = (
        <>
            <span className={styles.kropka} aria-hidden="true" />
            <span className={styles.kropka} aria-hidden="true" />
            <span className={styles.kropka} aria-hidden="true" />
        </>
    );

    if (ozdobne) {
        return <span className={klasy} aria-hidden="true" data-kropki-ladowania="">{kropki}</span>;
    }

    return (
        <span className={klasy} role="status" aria-live="polite" data-kropki-ladowania="">
            {kropki}
            <span className={styles.ukryty}>{etykieta}</span>
        </span>
    );
};

export default KropkiLadowania;
